/**
 * Card variant price swap
 * --------------------------------
 * On the collection grid, swaps the displayed price when a colour swatch
 * is selected on a product card. Renders every variant price into the card
 * (hidden via .hidden), then toggles visibility to match the chosen variant.
 *
 * Depends on:
 *   - .card-wrapper having a data-product="{handle}" attribute
 *   - swatch inputs being <input type="radio"> inside .card-wrapper
 *   - .card__price-wrapper containing .card__variant-price[data-variant-id]
 */
document.addEventListener('change', function (e) {
  const input = e.target;
  if (!input.matches('.card-wrapper input[type="radio"]')) return;

  const cardWrapper = input.closest('.card-wrapper');
  if (!cardWrapper) return;

  const productHandle = cardWrapper.dataset.product;
  const priceWrapper = cardWrapper.querySelector('.card__price-wrapper');
  if (!productHandle || !priceWrapper) return;

  // Find which variant matches all currently selected options on this card
  const allInputs = [...cardWrapper.querySelectorAll('input[type="radio"]:checked')];
  const selectedValues = allInputs.map((i) => i.value);

  fetch(`/products/${productHandle}.js`)
    .then((r) => r.json())
    .then((data) => {
      const match = data.variants.find((v) =>
        selectedValues.every((val) => v.options.includes(val))
      );
      if (!match) return;

      priceWrapper.querySelectorAll('.card__variant-price').forEach((el) => {
        el.classList.toggle('hidden', el.dataset.variantId !== String(match.id));
      });
    })
    .catch((err) => console.error('[card-variant-price] fetch failed:', err));
});